export default function getReadableTime(date) {
	const start = new Date(date)
	const startHours = start.getHours()
	const startMinutes = ('0' + start.getMinutes()).slice(-2)
	const startTime = `${startHours}:${startMinutes}`
	return startTime
}